import ProcessingFeeRatesTable from './ProcessingFeeRatesTable';

export default ProcessingFeeRatesTable;
